"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSelectionRenderer = void 0;
var tslib_1 = require("tslib");
var layout_page_1 = require("../../../../core/layout/main-structures/layout-page");
var log_1 = require("../../../../core/rich-utils/debug/logger/base-logger/log");
var log_source_1 = require("../../../../core/rich-utils/debug/logger/base-logger/log-source");
var document_renderer_1 = require("../common/document-renderer");
var selection_renderer_base_1 = require("./selection-renderer-base");
var SearchSelectionRenderer = (function (_super) {
    tslib_1.__extends(SearchSelectionRenderer, _super);
    function SearchSelectionRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.layoutPageFlag = layout_page_1.LayoutPageFlags.IsSearchSelectionRendered;
        return _this;
    }
    SearchSelectionRenderer.prototype.renderAllPageSelection = function (layout, pageIndex, force) {
        _super.prototype.renderAllPageSelection.call(this, layout, pageIndex, force);
        log_1.Log.print(log_source_1.LogSource.SelectionRenderer, "renderAllPageSearchSelection", "pageIndex: " + pageIndex);
    };
    SearchSelectionRenderer.prototype.closeDocument = function () {
        this.getLayoutSelectionInfo().reset();
    };
    SearchSelectionRenderer.prototype.getLayoutSelectionInfo = function () {
        return this.layoutSelection.searchInfo;
    };
    SearchSelectionRenderer.prototype.getContainer = function (pageElement) {
        return document_renderer_1.DocumentRenderer.getSearchSelectionContainerCore(pageElement);
    };
    return SearchSelectionRenderer;
}(selection_renderer_base_1.SelectionRendererBase));
exports.SearchSelectionRenderer = SearchSelectionRenderer;
